import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'
import storeHelper from '@/store/helper'
import fileDownload from 'js-file-download'
import moment from 'moment'
export class FileService extends BaseService {
  static async fetchAll(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.summary.file.get-list'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async fetchOne(id) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.summary.file.detail'),
        { id }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getListResult(id) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.summary.file.get-list-result'),
        { id }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async read(id) {
    try {
      const response = await this.request({ auth: true }).get(
        storeHelper.getUrl('cnps.kpi.file.read'),
        { params: { id } }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async import(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.kpi.file.import'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async downloadErrorFile(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.summary.file.download-error'),
        params,
        {
          responseType: 'blob',
        }
      )

      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      fileDownload(
        response.data,
        'Error_File' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
}
